import { useEffect, useState } from 'react';

/**
 * Tracks a media query from inside a component. CSS cannot do this alone here: the table's columns are data
 * handed to ag-grid, not markup, so the decision has to be made in JavaScript. Guarded for environments
 * without matchMedia - jsdom is one - where it answers "no" and the component renders its wide layout.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }

    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);

    update();
    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/** A phone. Room for a name and the buttons, and nothing else. */
export const PHONE_SCREEN = '(max-width: 575.98px)';

/** A small tablet. Room for the state as well. */
export const COMPACT_SCREEN = '(max-width: 767.98px)';

/** A tablet or a small laptop. Room for the printed link too, but not for everything. */
export const MEDIUM_SCREEN = '(max-width: 991.98px)';

/** A laptop. Room for all but the widest two columns; the full table needs 970px of its own. */
export const LARGE_SCREEN = '(max-width: 1199.98px)';
